function cleanString(string, output = null) {
  output = string.toLowerCase();
  return output
}

module.exports = {
  cleanString
};

